import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { EntityMetadata } from 'modules/domain/types'
import { InventoryTransferRequest } from './types'

const dict = (state: AppGlobalState) => state.inventoryInTransferRequest.items
const ids = (state: AppGlobalState) => state.inventoryInTransferRequest.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): InventoryTransferRequest | undefined =>
  state.inventoryInTransferRequest.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<InventoryTransferRequest> =>
  state.inventoryInTransferRequest.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.inventoryInTransferRequest.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.inventoryInTransferRequest.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.inventoryInTransferRequest.listFetchError
const listFetchErrorDetail = (state: AppGlobalState) => state.inventoryInTransferRequest.listFetchErrorDetail
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: InventoryTransferRequest[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.inventoryInTransferRequest.filter
const sorting = (state: AppGlobalState) => state.inventoryInTransferRequest.sorting
const page = (state: AppGlobalState) => state.inventoryInTransferRequest.page
const total = (state: AppGlobalState) => state.inventoryInTransferRequest.total
const pageSize = (state: AppGlobalState) => state.inventoryInTransferRequest.pageSize
const pages = (state: AppGlobalState) =>
  Math.ceil(state.inventoryInTransferRequest.total / state.inventoryInTransferRequest.pageSize)
const updateProgress = (state: AppGlobalState) => state.inventoryInTransferRequest.updateProgress
const inRequestsCount = (state: AppGlobalState) => state.inventoryInTransferRequest.inRequestsCount

const InventoryInTransferRequestSelectors = {
  filter,
  sorting,
  page,
  total,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  listFetchErrorDetail,
  list,
  dict,
  ids,
  pageSize,
  pages,
  updateProgress,
  inRequestsCount,
}

export default InventoryInTransferRequestSelectors
